import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { Images } from '@constants/images';
import { AbstractClass } from "@classes/abstract.class";
import SignaturePad from "signature_pad";
declare var $: any;

@Component({
  standalone: false,
  selector: 'app-field-form',
  templateUrl: './field_form.component.html',
  styleUrls: ['./field_form.component.scss']
})

export class FieldFormComponent implements OnInit, AfterViewInit {
  @Input() myClass: AbstractClass | null = null;
  @Input() label: string = '';
  @Input() cellType: string = '';
  @Input() name: string = '';
  @Input() model: any = null;
  @Input() required = false;
  @Input() cols: number = 0;
  @Input() multiple: boolean = false;
  @Input() disabled: boolean = false;
  @Input() filter: boolean = false;
  @Input() centerLatLng: google.maps.LatLngLiteral = {
    lat: 0,
    lng: 0
  };
  @Output() changeAction = new EventEmitter();
  ckeConfig: any;
  public images = Images;
  // Canvas
  public canvasIsClear = true;
  /* Vars */
  public nutrientTypeSelected = 0;
  public photoImage = Images.header1_en_m;
  public specialFields = ['text', 'checkbox', 'signature', 'hidden', 'documentType', 'hiringCompany',
    'number', 'date', 'email', 'password', 'gender', 'image', 'rolGroup', 'workScheduleTypeID',
    'scheduledToID', 'datetime', 'latlong', 'isActive', 'userRoles', 'locationID', 'latlongTxt', 'button', 'tenant'];

  constructor(
    public elementRef: ElementRef
  ) {
  }

  ngOnInit(): void {
    this.ckeConfig = {
      allowedContent: false,
      extraPlugins: 'divarea',
      forcePasteAsPlainText: true
    };
  }

  ngAfterViewInit(): void {
    if (this.cellType === 'signature') {
      this.createSignature();
    }
  }

  public createSignature = () => {
    const dom: HTMLElement = this.elementRef.nativeElement;
    const canvas = dom.querySelector('canvas');
    if (canvas) {
      const signaturePad = new SignaturePad(canvas, {
        minWidth: 1,
        maxWidth: 1,
        penColor: "rgb(0, 0, 0)",
        backgroundColor: 'rgb(255, 255, 255)'
      });

      // Returns signature image as an array of point groups
      const data = signaturePad.toData();

      // Draws signature image from an array of point groups
      signaturePad.fromData(data);

      signaturePad.addEventListener("afterUpdateStroke", () => {
        this.canvasIsClear = signaturePad.isEmpty();
      });

      const btnCancel = document.getElementById('canvasCancel');
      btnCancel?.addEventListener('click', () => {
        signaturePad.clear();
        this.model[this.name] = {
          height: 0,
          timestamp: new Date(),
          uri: 'signature',
          fileName: 'signature',
          data: ''
        };
        this.canvasIsClear = signaturePad.isEmpty();
      });

      const btnApply  = document.getElementById('canvasApply');
      btnApply?.addEventListener('click', () => {
        const image = signaturePad.toDataURL();
        if (this.myClass !== null) {
          this.model[this.name] = {
            height: 50000,
            timestamp: new Date(),
            uri: 'signature',
            fileName: 'signature',
            data: image.split(',')[1]
          };
        }
      });
    }
  }

  selectFile($event: any, name: string) {
    if (this.myClass !== null) {
      this.myClass.model[name] = this.getImageBase64($event, name);
      // $('input[name="' + name + '"]').value = 'test';
    }
  }

  /**
   * Obtiene los datos de la imagen y la codifica en base64
   */
  private getImageBase64 = (image: any, name: string) => {
    const imageBase64 = {
      height: 0,
      timestamp: '',
      uri: '',
      fileName: '',
      data: ''
    };
    const file: File = image.target.files[0];
    const myDate = new Date();
    const myReader: FileReader = new FileReader();
    myReader.onloadend = (e: ProgressEvent<FileReader>) => {
      imageBase64.height = file.size;
      imageBase64.timestamp = '2019-01-06T17:16:40';
      imageBase64.uri = file.name;
      imageBase64.fileName = file.name;
      imageBase64.data = myReader.result?.toString().split(',')[1] ?? '';
      // $('#' + name).attr('src', e.target.result);
    };
    myReader.readAsDataURL(file);
    return imageBase64;
  }

  public whatIsMyWidth = (): number => {
    const canvasDiv = document.getElementById('canvas-div');
    if (canvasDiv)
      return canvasDiv.offsetWidth - 2;
    else
      return 300;
  }

  public setCheckBox = (event: any) => {
    this.model[this.name] = event.target.checked;
  }

  public setTextarea = (event: any) => {
    this.setModel(event.target.value);
  }

  public setModel = (event: any) => {
    this.model[this.name] = event;
  }

  public onChage = (event: any) => {
    this.changeAction.emit(event);
  }

  public setMinDateTime = (): string => {
    let minDateTime = '';
    if (this.myClass?.modelName === 'WorkSchedule') {
      if (this.name === 'startDate') {
        let tempDate = new Date();
        /* if (new Date(this.model['startDate']) < new Date()) {
          tempDate = new Date(this.model['startDate']);
        }*/
        minDateTime = this.transformDate( tempDate);
        // this.model['startDate'] = minDateTime;
      } else if (this.name === 'endDate') {
        const tempDate = this.transformDate(new Date(this.myClass.model['startDate'].toString()));
        minDateTime = this.transformDate(this.addHours(new Date(tempDate), 1));
        // this.model['endDate'] = minDateTime;
      }
    }
    return minDateTime;
  }

  public setDateTime = ($event: any) => {
    let minDateTime = '';
    if (this.myClass?.modelName === 'WorkSchedule') {
      if (this.name === 'startDate') {
        const tempDate = this.transformDate(new Date(this.myClass.model['startDate'].toString()));
        minDateTime = this.transformDate(this.addHours(new Date(tempDate), 1));
        this.model['endDate'] = minDateTime;
      }
    }
  }

  public transformDate = (date: Date): string => {
    return date.getFullYear() + '-' +
      ((date.getMonth() + 1) < 10 ? '0' : '') + (date.getMonth() + 1) + '-' +
      (date.getDate() < 10 ? '0' : '') + date.getDate() + 'T' +
      (date.getHours() < 10 ? '0' : '') + date.getHours() + ':' +
      (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
  }

  public addHours = (date: Date, hours: number) : Date => {
    date.setTime(date.getTime() + hours * 60 * 60 * 1000);
    return date;
  }
}
